import { adminHttpClient } from '../../../../commons/adminHttpClient'

const deleteSavedAttachment = (attachmentId: string): Promise<any> => {
  return adminHttpClient.put('/EEDashboard/GetReimbursed/Expense/RemoveAttachment', {
    attachmentId: attachmentId,
  })
}

export default deleteSavedAttachment
